import { styled } from "@mui/material/styles";
import { Stack } from "@mui/material";
import { HubButton } from "../inputs";

export const StyledNavStack = styled(Stack)(({ theme }) => ({
  width: "75px",
  maxWidth: "75px",
  minWidth: "75px",
  height: "100%",
  justifyContent: "space-between",
  gap: "10px",
  padding: "24px 10px",
  borderRight: "1px solid",
  borderColor: theme.palette.hubColors.greyLight,
  backgroundColor: theme.palette.hubColors.white,
}));

export const StyledNavButton = styled(HubButton, {
  shouldForwardProp: (prop) => !["active"].includes(prop),
})(({ active, theme }) => ({
  justifyContent: "start",
  transition: "all 0.15s ease",
  backgroundColor: "transparent",
  color: theme.palette.hubColors.greyShade,
  fontWeight: 500,
  "& .HubButton-IconStack": {
    flexDirection: "column",
    gap: "5px",
    width: "55px",
    cursor: "pointer",
    ".MuiTypography-root": {
      fontSize: 10,
      lineHeight: "14px",
    },
  },
  ".HubIcon": {
    border: "1px solid",
    borderColor: theme.palette.hubColors.greyMid,
    padding: "6px",
    borderRadius: "6px",
    backgroundColor: theme.palette.hubColors.greyLightest,
  },
  "& svg": {
    opacity: 0.7,
    transition: "opacity 0.15s ease",
  },
  ":hover": {
    backgroundColor: "transparent !important",
    color: theme.palette.hubColors.greyDark,
    "& svg": {
      opacity: 1,
    },
  },
  ...(active && {
    ".HubIcon": {
      border: "1px solid",
      borderColor: theme.palette.hubColors.mainFocus,
      padding: "6px",
      borderRadius: "6px",
      backgroundColor: theme.palette.hubColors.mainFocusLightest,
      color: theme.palette.hubColors.mainFocus,
    },
    fontWeight: 600,
    color: theme.palette.hubColors.greyDark,
    "& svg": {
      opacity: 1,
      strokeWidth: 2.5,
    },
    ":hover": {
      backgroundColor: "transparent",
      color: theme.palette.hubColors.greyDark2,
    },
  }),
}));
